const AbstractVerifoneResponseRecord = require('./AbstractVerifoneResponseRecord');

class VerifoneLogoutResponseRecord extends AbstractVerifoneResponseRecord {

}

module.exports = VerifoneLogoutResponseRecord;
